/**
 * The country selector's rows keep Horizon's selection on the focused row (THEME.md §7.23, §9.4 #47; D-131, T-207).
 * Horizon's localization.js picks the row marked `aria-selected` on Enter and moves that mark only with the arrow keys.
 * snippets/okt-localization-form.liquid puts the visitor's row in the Tab order, so a keyboard user could land on it
 * while another row was still marked from before (arrows, then Escape and open again), and Enter would switch to that
 * row's country. Here a focused row becomes the selected one, as in the WAI-ARIA listbox pattern (selection follows
 * focus), and when focus leaves the list (Escape, Tab, a click elsewhere) the selection and the Tab stop go back to the
 * visitor's row (`aria-current`), so the list opens again as the page drew it. Loaded by the snippet only when the
 * Header has Country blocks; the listeners serve every list, also after Horizon re-renders the header.
 */
const ROW = '.okt-localization [role="option"]:not([aria-disabled="true"])';

/**
 * Marks one row of a list as selected and makes it the list's Tab stop
 * @param {Element} list
 * @param {Element | null} row
 */
function select(list, row) {
  if (!row) return;
  for (const option of list.querySelectorAll(ROW)) {
    const own = option === row;
    option.setAttribute('aria-selected', String(own));
    if (option instanceof HTMLElement) option.tabIndex = own ? 0 : -1;
  }
}

document.addEventListener('focusin', (event) => {
  const row = event.target instanceof Element ? event.target.closest(ROW) : null;
  const list = row?.closest('[role="listbox"]');
  if (row && list) select(list, row);
});

document.addEventListener('focusout', (event) => {
  const row = event.target instanceof Element ? event.target.closest(ROW) : null;
  const list = row?.closest('[role="listbox"]');
  if (!row || !list || (event.relatedTarget instanceof Node && list.contains(event.relatedTarget))) return;
  select(list, list.querySelector(`${ROW}[aria-current="true"]`));
});
